import React, { Component } from 'react'
import TextShape from "../types/TextShape";
import RenderText from "../render-text";
import { GradientDefs } from "shape-edit/forms/fields";
import { getBackgroundObjectByShape } from 'template-edit/components/helper';
import { Size } from 'app/types/model-types';
import { EditModeType } from 'app/types/app-types';

interface Props {
    data: TextShape
    activeShapeId: string
    editMode: EditModeType
    updateShape: Function
}

interface State {
    newSize: Size
}

class TextSvg extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            newSize: null,
        }
    }

    setRealSize = (newSize: Size) => {
        this.setState({newSize: newSize})
    }

    render() {
        const shapeObject: TextShape = this.props.data
        const scale = shapeObject.scale && shapeObject.scale !== 0 ? shapeObject.scale : 1
        const backgroundObject = getBackgroundObjectByShape(shapeObject, this.state.newSize)

        const isShadow = shapeObject.shadow_color && shapeObject.shadow_sigma
        const h = Math.round(shapeObject.text_fontsize / scale)

        return (
            <g className={'draggable'}>
                {isShadow &&
                    <filter id={`shadow-${shapeObject.index}`} width="200%" height="200%" y="-50%" x="-50%">
                        <feDropShadow
                            dx={shapeObject.shadow_xoffset}
                            dy={shapeObject.shadow_yoffset}
                            stdDeviation={shapeObject.shadow_sigma}
                            floodColor={shapeObject.shadow_color}
                            floodOpacity={1 - shapeObject.shadow_opacity / 100}
                        />
                    </filter>
                }

                {shapeObject.gradient_id && shapeObject.gradient &&
                    <GradientDefs gradient={shapeObject.gradient} idx={shapeObject.gradient_id} />
                }

                {backgroundObject}

                <RenderText
                    shape={shapeObject}
                    fontSize={h}
                    width={shapeObject.width}
                    h={shapeObject.height}
                    setRealSize={this.setRealSize}
                    offsetY={0}
                    activeShapeId={this.props.activeShapeId}
                    updateShape={this.props.updateShape}
                    editMode={this.props.editMode}
                />
            </g>
        )
    }
}

export default TextSvg
